export default __webpack_public_path__ + "static/media/3234E467-A763-485D-B424-600EA16565B5_1_102_o.2f472726.jpeg";